/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-undef,
    prefer-const,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import UserConstants from 'constants/UserConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'
import { deleteAccessToken } from '@driftt/web-auth'
import CustomerHelpers from 'shared-web/src/helpers/CustomerHelpers'
import { fetchOauthCode as fetchOauthCodeApi, fetchOAuthAppInfo as fetchOAuthAppInfoApi } from 'app/api/TokenAPI.js'

const UserQueries = Marty.createQueries({
  id: 'UserQueries',

  createUserWithEmail(email) {
    const promise = this.app.sources.UserAPI.createUserWithEmail(email)
    promise.then(res => {
      if (res.status === 200) {
        const { user } = res.body
        const { accessToken } = res.body
        return this.dispatch(UserConstants.USER_CREATE_WITH_EMAIL_DONE, email, user, accessToken)
      } else if (res.status === 400) {
        return this.dispatch(UserConstants.EMAIL_ALREADY_REGISTERED, email)
      } else {
        captureResponseException(res)
        return this.dispatch(UserConstants.USER_CREATE_WITH_EMAIL_FAILED, email, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.USER_CREATE_WITH_EMAIL_FAILED, email, error)
    })
  },

  sendWelcomeEmail(isMobile) {
    const promise = this.app.sources.UserAPI.sendWelcomeEmail(isMobile)
    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(UserConstants.SEND_WELCOME_EMAIL_DONE)
      } else {
        captureResponseException(res)
        return this.dispatch(UserConstants.SEND_WELCOME_EMAIL_FAILED)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.SEND_WELCOME_EMAIL_FAILED)
    })
  },

  fetchUser(userId) {
    const promise = this.app.sources.UserAPI.fetchUser(userId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(UserConstants.USER_FETCH_DONE, userId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(UserConstants.USER_FETCH_FAILED, userId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.USER_FETCH_FAILED, userId, error)
    })
  },

  fetchUsersForOrgId(orgId) {
    const promise = this.app.sources.UserAPI.fetchUsersForOrgId(orgId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(UserConstants.FETCH_USERS_FOR_ORG_ID_DONE, orgId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(UserConstants.FETCH_USERS_FOR_ORG_ID_FAILED, orgId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.FETCH_USERS_FOR_ORG_ID_FAILED, orgId, error)
    })
  },

  fetchCurrentLoggedInUser() {
    return this.app.sources.UserAPI.fetchCurrentLoggedInUser().then(res => {
      if (res.status === 200) {
        return this.dispatch(UserConstants.FETCH_CURRENT_USER_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(UserConstants.FETCH_CURRENT_USER_FAILED)
      }
    }).catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.FETCH_CURRENT_USER_FAILED, error)
    })
  },

  checkUserEmailExistence(email) {
    return this.app.sources.UserAPI.getUserExistsByEmail(email).then(res => {
      if (res.status === 200) {
        return this.dispatch(UserConstants.CHECK_USER_EXISTENCE_BY_EMAIL_DONE, email, true)
      } else if (res.status === 404) {
        return this.dispatch(UserConstants.CHECK_USER_EXISTENCE_BY_EMAIL_DONE, email, false)
      } else {
        this.dispatch(UserConstants.CHECK_USER_EXISTENCE_BY_EMAIL_FAILED, email, res)
        return captureResponseException(res)
      }

    }).catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_FAILED, email, orgHandle, error)
    })
  },

  getUserExistenceByEmailAndOrgHandle(email, orgHandle) {
    return this.app.sources.UserAPI.getUserExistsByEmailAndOrgHandle(email, orgHandle).then(res => {
      if (res.status === 200) {
        return this.dispatch(UserConstants.CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_DONE, email, orgHandle, true)
      } else if (res.status === 404) {
        return this.dispatch(UserConstants.CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_DONE, email, orgHandle, false)
      } else {
        this.dispatch(UserConstants.CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_FAILED, email, orgHandle, res)
        return captureResponseException(res)
      }

    }).catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_FAILED, email, orgHandle, error)
    })
  },

  updateUser(...args) {
    let obj = args[0],
      { userId,
      params,
      isCurrentUser } = obj,
      val = obj.notify,
      notify = val != null ? val : false
    const updateUserPromise = this.app.sources.UserAPI.updateUser(userId, params)
    updateUserPromise.then(res => {
      if (res.status !== 200) {
        captureResponseException(res)
        this.app.actions.NotificationActions.pushNotification({
          content: res.body.message,
          variant: 'red',
          sticky: true
        })
        return this.dispatch(UserConstants.USER_UPDATE_FAILED, userId, res)
      } else {
        this.dispatch(UserConstants.USER_UPDATE_DONE, userId, res.body, params)
        if (notify) {
          const prefix = isCurrentUser ? 'Your' : `${ CustomerHelpers.getDisplayName(res.body) }'s`
          return this.app.actions.NotificationActions.pushNotification({
            content: `${ prefix } profile update has been saved!`
          })
        }
      }
    })

    return updateUserPromise.catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.USER_UPDATE_FAILED, userId, error)
    })
  },

  fetchOauthCode({ redirect_uri, client_id }) {
    return fetchOauthCodeApi({ redirect_uri, client_id })
      .then(res => {
        return res.json().then(body => {
          if (res.ok) {
            return this.dispatch(UserConstants.FETCH_OAUTH_CODE_DONE, { redirect_uri, client_id, body })
          } else {
            return this.dispatch(UserConstants.FETCH_OAUTH_CODE_FAILED, { redirect_uri, client_id, body })
          }
        })
      }).catch(errors => captureException(errors))
  },

  fetchOauthAppInfo(client_id) {
    return fetchOAuthAppInfoApi(client_id)
      .then(res => {
        if (res.ok) {
          return res.json().then(body => {
            return this.dispatch(UserConstants.FETCH_OAUTH_APP_DONE, { client_id, app: body })
          })
        } else if (res.status === 404) {
          return this.dispatch(UserConstants.FETCH_OAUTH_APP_DONE, { client_id, app: 'NOT_FOUND' })
        }
      }).catch(errors => captureException(errors))
  },

  clearPasswordValidationErrors() {
    this.dispatch(UserConstants.CLEAR_PASSWORD_VALIDATION_ERRORS)
  },

  changePassword(userId, password, notify) {
    if (notify == null) { notify = true }

    return this.app.sources.UserAPI.changePassword(userId, password).then(res => {
      if (res.status === 200) {
        if (notify) {
          this.app.actions.NotificationActions.pushNotification({
            content: 'Your password has been changed!'
          })
        }
        return this.dispatch(UserConstants.CHANGE_PASSWORD_DONE, userId, res.body)
      } else {

        const validationErrors = _.get(res, 'body.errors', [])
        this.dispatch(UserConstants.CHANGE_PASSWORD_FAILED, userId, validationErrors)

        const error = new Error()
        error.isValidationError = true

        return Promise.reject(error)
      }
    }).catch(error => {

      if (!error.isValidationError) {
        captureException(error)
        this.dispatch(UserConstants.CHANGE_PASSWORD_FAILED, userId, [])
        this.app.actions.NotificationActions.pushNotification({
          content: 'Ooops, we couldn’t set your password. Please try again.',
          variant: 'red',
        })
      }

      return Promise.reject(error)
    })
  },

  uploadUserAvatar(userId, file) {
    const avatarUploadPromise = this.app.sources.UserAPI.uploadUserAvatar(userId, file)
    avatarUploadPromise.then(res => {
      if (res.status === 200) {
        return this.dispatch(UserConstants.USER_AVATAR_UPLOAD_DONE, userId, file)
        // suppressing this until we can design a solution compatible with new
        // per-rep onboarding flow
        // @app.actions.NotificationActions.pushNotification({
        //   content: 'Your avatar has been updated!'
        // })
      } else {
        this.app.actions.NotificationActions.pushNotification({
          content: res.body.message,
          variant: 'red'
        })
        captureResponseException(res)
        return this.dispatch(UserConstants.USER_AVATAR_UPLOAD_FAILED, userId, res)
      }
    })

    return avatarUploadPromise.catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.USER_AVATAR_UPLOAD_FAILED, userId, error)
    })
  },

  logoutUser() {
    this.dispatch(UserConstants.LOGOUT_USER_STARTING)
    deleteAccessToken()
    return this.dispatch(UserConstants.LOGOUT_USER_DONE)
  },

  archiveUser(userId) {
    const userPromise = this.app.sources.UserAPI.archiveUser(userId)

    userPromise.then(res => {
      if (res.status === 200) {
        return this.dispatch(UserConstants.USER_ARCHIVE_DONE, userId)
      } else {
        captureResponseException(res)
        return this.dispatch(UserConstants.USER_ARCHIVE_FAILED, userId)
      }
    })

    return userPromise.catch(error => {
      captureException(error)
      return this.dispatch(UserConstants.USER_ARCHIVE_FAILED, userId, error)
    })
  },

  archiveUsers(payload) {
    const { ARCHIVE_USERS_DONE, ARCHIVE_USERS_FAILED } = UserConstants
    return this.app.sources.UserAPI.archiveUsers(payload)
      .then(res => {
        if (res.status !== 200) {
          throw res
        }
        return this.dispatch(ARCHIVE_USERS_DONE, payload.userIds)
      })
      .catch(error => {
        captureException(error)
        return this.dispatch(ARCHIVE_USERS_FAILED, payload, error)
      })
  }
})

export default UserQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/UserQueries.js